module.exports = function (max = 5, current) {
  let count = 1;
  let options = '';
  while (count <= max) {
    options += `<option value="${count}" ${current === count ? 'selected' : ''}>${count}</option>`;
    count += 1;
  }
  return options;
};
